import { render, staticRenderFns } from "./ReceiptWithholdingHistory.vue?vue&type=template&id=2fe00051&scoped=true"
import script from "./ReceiptWithholdingHistory.vue?vue&type=script&lang=js"
export * from "./ReceiptWithholdingHistory.vue?vue&type=script&lang=js"
import style0 from "./ReceiptWithholdingHistory.vue?vue&type=style&index=0&id=2fe00051&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe00051",
  null
  
)

export default component.exports